import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderEs = () => {
    return (
        <HighlightedText
            text="RECLAMA TU BONO"
            highlights={[{ word: 'RECLAMA' }, { word: 'TU' }, { word: 'BONO' }]}
            className={common.text_header}
        />
    )
}

export const TextLandEs = () => {
    return (
        <HighlightedText
            text="325 % de bono + 400 GIROS GRATIS"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['bono']}
            className={styles.text_content}
        />
    )
}
